import React, { useEffect, useRef, useState } from 'react'
import { AiOutlineSearch } from "react-icons/ai";
import Welcome from '../ui/Welcome';

function FindUser({ findUserHandler, welcome }) {
    useEffect(() => {
        focusRef.current.focus()
    }, [])
    const [name, setName] = useState("")
    const focusRef = useRef()
    // console.log(name)
    return (
        <div className="search" >
            <div className="search-bar">
                <AiOutlineSearch className="icon" />
                <input type="text" className="input" value={name} onChange={e => setName(e.target.value)} ref={focusRef} placeholder="Search user" />
            </div>
            <button className="btn btn-find" onClick={() => findUserHandler(name, setName)} >
                Search
            </button>
            {
                welcome && <Welcome />
            }

        </div>
    )
}

export default FindUser
